import { NetworkStatusService } from "../network-status.service";

export abstract class ApiService<T> {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: T,
    protected onlineService: T
  ) {}

  public get isOnline() {
    return this.networkStatusService.isOnline;
  }

  public get service() {
    return this.isOnline ? this.onlineService : this.offlineService;
  }
}
